import { LEGAL } from "@/content/site";

export const LegalDisclaimer = ({ dark = false, testId = "legal-disclaimer" }) => (
  <p className={`text-sm leading-relaxed ${dark ? "text-stone-300" : "border-l-2 border-gold bg-white p-5 text-stone-600"}`} data-testid={testId}>
    <strong className={dark ? "text-ivory" : "text-ink"}>Legal Disclaimer:</strong> {LEGAL}
  </p>
);
